import { computeExpirationDate } from '../../utils/incomeAccess';

export const COOKIES_DAYS_TO_LIVE = 365 * 15; // ~15 years
export const installPromptCookieExpirationDate = computeExpirationDate(COOKIES_DAYS_TO_LIVE);

export const oddsAutoAcceptOddsChangeCookieKey = 'autoAcceptOddsChange';

export const appInstallPrompt = 'appInstallPrompt';

export const kwiffCookieAcceptanceKey = 'kwiffCookieAcceptance';

export const REVIEW_PROMPT_TIMEOUT_COOKIE_DAYS_TO_LIVE = 7;
export const reviewPromptTimeoutExpirationDate = computeExpirationDate(REVIEW_PROMPT_TIMEOUT_COOKIE_DAYS_TO_LIVE);
export const reviewPromptLeftReviewExpirationDate = computeExpirationDate(COOKIES_DAYS_TO_LIVE);
export const reviewPromptTimeout = 'reviewPromptTimeout';
export const reviewPromptLeftReview = 'reviewPromptLeftReview';

export const NET_PROMOTER_SCORE_DISMISSED_COOKIE_DAYS_TO_LIVE = 7;
export const NET_PROMOTER_SCORE_SUBMITTED_COOKIE_DAYS_TO_LIVE = 30;
export const netPromoterScoreViewedExpirationDate = computeExpirationDate(NET_PROMOTER_SCORE_DISMISSED_COOKIE_DAYS_TO_LIVE);
export const netPromoterScoreSubmittedExpirationDate = computeExpirationDate(NET_PROMOTER_SCORE_SUBMITTED_COOKIE_DAYS_TO_LIVE);
export const netPromoterScoreViewed = 'netPromoterScoreViewed';
export const netPromoterScoreSubmitted = 'netPromoterScoreSubmitted';

export const showTotalStakesToggleStatusCookieKey = 'showTotalStakesToggleStatus';

export const POST_HOG_SURVEY_DISMISSED_COOKIE_DAYS_TO_LIVE = 7;
export const POST_HOG_SURVEY_SUBMITTED_COOKIE_DAYS_TO_LIVE = 30;
export const postHogSurveyViewedWithoutSubmitExpirationDate = computeExpirationDate(POST_HOG_SURVEY_DISMISSED_COOKIE_DAYS_TO_LIVE);
export const postHogSurveySubmittedExpirationDate = computeExpirationDate(POST_HOG_SURVEY_SUBMITTED_COOKIE_DAYS_TO_LIVE);

export const preferredLanguage = 'preferredLanguage';

export const appTourStatusCookieKey = 'appTourStatus';
export const appTourFeaturedPageCookieKey = 'appTourFeaturedPage';
export const appTourNavTabsCookieKey = 'appTourNavTabs';
export const appTourSubNavTabsCookieKey = 'appTourSubNavTabs';
export const appTourEventCardCookieKey = 'appTourEventCard';
export const appTourBetSlipCombosHighlightedCookieKey = 'appTourBetSlipCombosHighlighted';
export const appTourBetSlipCombosExtraOptionsCookieKey = 'appTourBetSlipCombosExtraOptions';
export const appTourBetSlipCombosPlaceBetCookieKey = 'appTourBetSlipCombosPlaceBet';
export const appTourBetSuperchargedCookieKey = 'appTourBetSupercharged';
export const appTourMyBetsCashOutCookieKey = 'appTourMyBetsCashOut';
export const appTourSuperchargedCashOutCookieKey = 'appTourSuperchargedCashOut';
export const appTourSkipped = 'appTourSkipped';

export const hasSeenMyAchievementsPreview = 'hasSeenMyAchievementsPreview';
